import React, { useEffect, useState } from "react";
import {
  bidFarmerRequest,
  fetchNewFarmerRequestList,
} from "../../action/farmerProducts";
import { Loader } from "../loader";
import moment from "moment";
import {
  handleCurrency,
  handleKeyDown,
} from "../../helper/helper";
import infoBtn from "../../assets/images/info-circle.svg";
import { useNavigate } from "react-router-dom";
import { fetchAddresses } from "../../action/location";
import Pagination from "../pagination/paginationView";
import { useFormik } from "formik";
import { getunits } from "../../action/users";
import showNotification from "../notification/showNotification";
import Offcanvas from "react-bootstrap/Offcanvas";
import ReactSelect from "react-select";
import { SearchBox } from "../SearchBox";
import leftArrow from "../../assets/images/navigate_left.svg";
import { Link } from "react-router-dom";

const NewReq = () => {
  const [newRequest, setNewRequest] = useState({
    loading: false,
    data: null,
    totalRecords: 0,
    currentPage: 1,
    pageSize: 10,
  });
  const [showBidCanvas, setShowBidCanvas] = useState(false);
  // const [search, setSearch] = useState("");
  const [parentId, setParentId] = useState("");
  const [selectOption, setSelectOption] = useState([]);
  const [addressList, setAddressList] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [units, setUnits] = useState([]);
  const [search, setSearch] = useState("");

  const navigate = useNavigate();

  const fetchNewRequestList = async (searchValue = "") => {
    setNewRequest((i) => ({
      ...i,
      loading: true,
    }));
    const response = await fetchNewFarmerRequestList(
      newRequest.currentPage,
      newRequest.pageSize,
      searchValue
    );
    if (response.status) {
      setNewRequest((i) => ({
        ...i,
        loading: false,
        data: response?.data?.list,
        totalRecords: response?.data?.count,
      }));
    } else {
      setNewRequest((i) => ({
        ...i,
        loading: false,
        data: null,
        totalRecords: 0,
      }));
    }
  };

  const fetchUnits = async () => {
    const response = await getunits();
    if (response.status) {
      setUnits(response.data);
    }
  };

  const fetchDeliveryAddress = async () => {
    const response = await fetchAddresses();
    if (response.status) {
      setAddressList(response.list);
    }
  };

  useEffect(() => {
    fetchUnits();
    fetchDeliveryAddress();
  }, [])
  const addBidFormik = useFormik({
    initialValues: {
      parentId: "",
      price: "",
      deliveryDate: "",
      quantity: "",
      unitId: "",
      addressId: "",
    },
    onSubmit: async (values) => {
      if (!selectedOption?.value) {
        showNotification(
          "Select Address",
          "Please select delivery address",
          "danger"
        );
        return;
      }
      values.addressId = selectedOption.value;

      const response = await bidFarmerRequest(values);
      if (response.status) {
        navigate("/farmer-products/applied-requests");
        showNotification("Applied Bid Request", response.message, "success");
        setShowBidCanvas(false);
      } else {
        showNotification("Applied Bid Request", response.message, "danger");
        setShowBidCanvas(false);
      }
      addBidFormik.handleReset();
    },
  });

  useEffect(() => {
    fetchNewRequestList(search);
    // fetchDeliveryAddress()
  }, [newRequest.currentPage, newRequest.pageSize, search]);

  const getMSP = (price, unit) => {
    if (price) {
      return `${price} / ${unit}`;
    }

    return "--";
  };
  return (
    <>
      <div className="payout_data-content">
        <div className="payout_data-head">
          <div className="payout_data-head-top">
            <div className="payout_data-left p-0">
              <div className="payout_data_ttl">Request List</div>
            </div>
            <div className="payout_data-right">
              <button
                onClick={() => {
                  navigate(-1);
                }}
                className="back_btnn"
              >
                {" "}
                <img
                  src={leftArrow}
                  alt="Arrow"
                  className="navi_left"
                /> Back{" "}
              </button>
            </div>
          </div>
        </div>
        <div className="search_container mb-4">
          <SearchBox search={search} setSearch={setSearch} />
        </div>
        <div className="new-tab_box">
          <ul className="bidtab">
            <li className="active"><Link to="/farmer-products/new-requests">New Requests</Link></li>
            <li><Link to="/farmer-products/applied-requests">Applied Requests</Link></li>
            <li><Link to="/farmer-products/confirmed-requests">Confirmed Requests</Link></li>
            <li><Link to="/farmer-products/rejected-requests">Rejected Requests</Link></li>
            <li><Link to="/farmer-products/closed-requests">Close Requests</Link></li>
          </ul></div>
        <div className="overflow_auto">
          <table className="payout_table upi-mandate_table">
            <thead>
              <tr className="tableHead">
                <th className="thHeader">
                  <div className="payoutHead hndIcon">Order ID</div>
                </th>
                <th className="thHeader">
                  <div className="payoutHead hndIcon">Request Date</div>
                </th>
                <th className="thHeader">
                  <div className="payoutHead hndIcon">Farmer Name</div>
                </th>
                <th className="thHeader">
                  <div className="payoutHead"> Address</div>
                </th>
                <th className="thHeader">
                  <div className="payoutHead">Product</div>
                </th>
                <th className="thHeader">
                  <div className="payoutHead">Variety</div>
                </th>
                <th className="thHeader">
                  <div className="payoutHead">Grade</div>
                </th>
                <th className="thHeader">
                  <div className="payoutHead">MSP</div>
                </th>
                <th className="thHeader">
                  <div className="payoutHead">Price </div>
                </th>

                <th className="thHeader">
                  <div className="payoutHead">Quantity </div>
                </th>
                <th className="thHeader">
                  <div className="payoutHead">Total Price </div>
                </th>
                <th className="thHeader">
                  <div className="payoutHead text-center">Action </div>
                </th>
              </tr>
            </thead>

            <tbody>
              {newRequest.loading ? (
                <tr>
                  <td colSpan="12">
                    <Loader />
                  </td>
                </tr>
              ) : newRequest?.data?.length > 0 ? (
                newRequest.data.map((item) => {
                  return (
                    <tr key={item._id}>
                      <td className="phone_number noWrap">
                        {item?.orderId ?? "-"}
                      </td>
                      <td className="phone_number noWrap">
                        {moment(item?.createdAt).format("DD-MM-YYYY")}
                      </td>
                      <td className="Status">{item?.userDetails?.name}</td>
                      <td className="Status">{item?.gaons?.name}</td>
                      <td className="table_amount">
                        {
                          item?.product[0]?.verietyDetails[0]?.productDetails?.name
                            .en
                        }
                      </td>

                      <td className="table_amount ">
                        {item?.product[0]?.verietyDetails[0]?.name.en}
                      </td>

                      <td className="">{item?.grade}</td>
                      <td className="table_amount ">
                        {getMSP(
                          item?.product[0]?.verietyDetails[0]?.mspDetails
                            ?.minimum_selling_price,
                          item?.product[0]?.verietyDetails[0]?.mspDetails?.unit
                            ?.shortcode
                        )}
                      </td>

                      <td className="Status bold_txt">
                        <div>
                          {handleCurrency()} {item?.price ?? 0} / {item?.perUnit}
                        </div>
                      </td>

                      <td className="Status bold_txt">
                        <div>
                          {item?.quantity}{" "}
                          {item?.unit ? item?.unit : ""}
                        </div>
                      </td>
                      <td className="bold_txt">
                        <div>
                          {/* {handleCurrency()}{" "} */}
                          {/* {(item?.price ?? 0) *
                        (item?.quantity ?? 0) *
                        (item?.conversion ?? 0)} */}
                          {/* {(
                        (item?.priceConversion ?? 0) *
                        (item?.quantity ?? 0) *
                        (item?.conversion ?? 0)
                      ).toFixed(2)} */}
                          {handleCurrency()}{" "}
                          {(
                            Math.floor(
                              (item?.priceConversion ?? 0) *
                              (item?.quantity ?? 0) *
                              (item?.conversion ?? 0)
                            )
                          ).toFixed(2)}



                        </div>
                      </td>
                      <td>
                        <div className="flex_btn text-center">
                          <img
                            src={infoBtn}
                            onClick={() => {
                              navigate(`/farmer/products/details/${item._id}`);
                            }}
                            alt="info btn"
                          />
                          <button
                            color="dark"
                            className="noWrap btn btn-primary"
                            isLight="btn btn-primary"
                            tag="a"
                            onClick={() => {
                              setParentId(item?._id);
                              addBidFormik.values.parentId = item?._id;
                              setShowBidCanvas(true);
                              addBidFormik.setValues({
                                parentId: item?._id,
                                price: item?.price,
                                quantity: item?.quantity,
                                unitId: item?.unitId,
                                deliveryDate: moment(item?.deliveryDate).format(
                                  "YYYY-MM-DD"
                                ),
                              });

                              if (addressList?.length) {
                                console.log("address id", addressList);
                                const options = addressList.map((item) => {
                                  console.log("adress id", item._id);
                                  return {
                                    value: item._id || "", // Use a unique identifier if available
                                    label: `${item.location?.address || ""} ${item.postalCode || ""
                                      }`,
                                  };
                                });

                                setSelectOption(options);

                              }
                            }}
                          >
                            Apply Bid
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <>
                  <tr>
                    <td colSpan="10" className="text_center">
                      No data available
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          currentPage={newRequest?.currentPage}
          totalCount={newRequest?.totalRecords}
          pageSize={newRequest?.pageSize}
          onPageChange={(page) =>
            setNewRequest((i) => ({
              ...i,
              currentPage: page,
            }))
          }
          changePageSize={(size) =>
            setNewRequest((i) => ({
              ...i,
              currentPage: 1,
              pageSize: size,
            }))
          }
          showPageSizeView={newRequest?.totalRecords > 5 ? true : false}
        />

        <Offcanvas
          show={showBidCanvas}
          onHide={() => {
            setShowBidCanvas(false);
            addBidFormik.handleReset();
          }}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Apply Bid</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="add_buyer_content">
              <form action="" onSubmit={addBidFormik.handleSubmit}>
                <div className="row">
                  <div className="col-lg-12">
                    <p className="modal_desc">
                      Note: This section is for entering the request details to
                      be sent to the farmer, including the required quantity,
                      the offered price, and the preferred delivery date for the
                      products.
                    </p>
                    <div className="input-box">
                      <div className="input-label">
                        Delivery Address
                        <span>*</span>
                      </div>

                      <ReactSelect
                        options={selectOption}
                        value={selectedOption}
                        onChange={(e) => {
                          setSelectedOption(e);
                        }}
                        placeholder="Select Delivery Address"
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="input-box">
                      <div className="input-label">
                        Quantity
                        <span>*</span>
                      </div>
                      <div className="input_field">
                        <input
                          type="number"
                          className="input"
                          placeholder="Enter quantity"
                          id="beneficiary"
                          name="quantity"
                          max="100000000"
                          onChange={(e) => {
                            addBidFormik.setFieldValue(
                              "quantity",
                              Number(e.target.value)
                            );
                          }}
                          value={
                            addBidFormik.values.quantity == 0
                              ? ""
                              : addBidFormik.values.quantity
                          }
                          required
                          onKeyDown={handleKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="input-box">
                      <div className="input-label">
                        Unit
                        <span>*</span>
                      </div>
                      <div className="input_field">
                        <select
                          className="input"
                          value={addBidFormik?.values?.unitId ?? ""}
                          onChange={(e) => {
                            addBidFormik.setFieldValue(
                              "unitId",
                              e.target.value
                            );
                          }}
                          required
                        >
                          <option value="">Select Unit</option>
                          {units.map((unit) => {
                            return (
                              <option
                                key={unit._id}
                                id={unit._id}
                                value={unit._id}
                              >
                                {unit.shortcode}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="input-box">
                      <div className="input-label">
                        Price/Kg
                        <span>*</span>
                      </div>
                      <div className="input_field">
                        <input
                          type="number"
                          className="input"
                          placeholder="Enter price"
                          id="beneficiary"
                          name="price"
                          max="1000000"
                          onChange={(e) => {
                            addBidFormik.setFieldValue(
                              "price",
                              Number(e.target.value)
                            );
                          }}
                          value={
                            addBidFormik.values.price == 0
                              ? ""
                              : addBidFormik.values.price
                          }
                          onKeyDown={handleKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="input-box">
                      <div className="input-label">
                        Select a delivery date
                        <span>*</span>
                      </div>
                      <div className="input_field">
                        <input
                          required
                          name="deliveryDate"
                          className="input"
                          type="date"
                          placeholder="select date"
                          value={addBidFormik.values.deliveryDate}
                          min={moment(new Date()).format("YYYY-MM-DD")}
                          onChange={addBidFormik.handleChange}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex_btn mt-3 ">
                  <button className="btn btn-success" type="submit">
                    Send Request
                  </button>
                </div>
              </form>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
};

export default NewReq;
